import React from 'react';
import { useNavigate } from 'react-router-dom';
import IntroPage from '../newtab/IntroPage';
import { I18nProvider } from '../../i18n/I18nContext';

const HomePage = () => {
  const navigate = useNavigate();

  const handleTryNow = () => {
    // 保存用户已点击过"立即体验"按钮
    localStorage.setItem('skipIntroPage', 'true');
    // 跳转到新标签页
    navigate('/newtab');
  };

  return (
    <I18nProvider>
      <IntroPage onTryNow={handleTryNow} visible={true} />
    </I18nProvider>
  );
};

export default HomePage; 